import * as R from 'ramda';
import React, { useEffect } from 'react';
// helpers/constants
import * as G from '../../../../helpers';
import * as GC from '../../../../constants';
// ui
import { ReactSelect } from '../../../../ui';
//////////////////////////////////////////////////

const ReactSelectInput = (props) => {
  const {
    id,
    value,
    isMulti,
    options,
    hasError,
    disabled,
    onKeyDown,
    placeholder,
    useMaxHeight,
    setFieldValue,
    shouldValidate,
    setFieldTouched,
    closeMenuOnSelect,
    closeMenuOnScroll,
    useMenuPortalTarget,
  } = props;

  useEffect(() => {
    if (G.isNotNilAndNotEmpty(shouldValidate)) {
      const validate = G.ifElse(shouldValidate, shouldValidate, false);

      setFieldTouched(id, true, validate);
    }
  }, []);

  const handleBlur = () => {
    const validate = G.ifElse(G.isNotNilAndNotEmpty(shouldValidate), shouldValidate, true);

    setFieldTouched(id, true, validate);
  };

  const handleChange = (val) => {
    const inputValue = G.ifElse(
      R.isNil(val),
      {
        value: null,
        label: null,
      },
      val,
    );

    if (G.isTrue(isMulti)) {
      const data = R.map(
        (item) => R.prop('value', item),
        inputValue,
      );

      setFieldValue(id, data);
    } else {
      setFieldValue(id, R.prop('value', inputValue));
    }
  };

  return (
    <ReactSelect
      id={id}
      value={value}
      isMulti={isMulti}
      options={options}
      hasError={hasError}
      onBlur={handleBlur}
      onKeyDown={onKeyDown}
      onChange={handleChange}
      placeholder={placeholder}
      useMaxHeight={useMaxHeight}
      isDisabled={disabled || false}
      closeMenuOnScroll={closeMenuOnScroll}
      useMenuPortalTarget={useMenuPortalTarget}
      closeMenuOnSelect={closeMenuOnSelect || true}
    />
  );
};

export default ReactSelectInput;
